import { DatabaseReference, ref } from "firebase/database";
import { CollectionReference, DocumentData, collection } from "firebase/firestore";
import { database, firestore } from "../../../core/utils/firebase";
import { Column } from "./DataTableInterfaces";

export abstract class IDataTableRepository {
    protected dataCollection: CollectionReference<DocumentData, DocumentData>;
    protected realDbRef: DatabaseReference;
    constructor(public name: string, public columns:Column[]) {
        this.dataCollection = collection(firestore, this.name);
        this.realDbRef = ref(database, this.name);
    }
    abstract getAll: () => Promise<Object[]>;
    abstract add: (data: Object) => Promise<Object>;
    abstract uploadFile: (filename: string, blob: Blob) => Promise<string>;
    abstract update: (data: Object, id: string) => Promise<Object>;
    abstract delete: (id: string) => Promise<void>;
}